var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEd4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.92,
    y: 406,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.92,
    y: 406,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 406,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.92,
    y: 406,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.92,
    y: 380.17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.92,
    y: 380.17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 380.17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.92,
    y: 380.17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 200,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 200,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 200,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,119.667V77.333h-51.04V51.04h-26.293V0h-42.334v51.04h-20.666V0h-42.334v51.04h-20.666V0h-42.334v51.04h-20.667V0 h-42.333v51.089l-20.667-0.007V0h-42.333v51.069l-20.667-0.007V0H77.333v51.048L51.04,51.04v26.293H0v42.334h51.04v20.666H0 v42.334h51.04v20.666H0v42.334h51.04v20.666H0v42.334h51.04v20.666H0v42.334h51.04v20.666H0v42.334h51.04v26.243l26.293,0.003 V512h42.333v-51.082l20.667,0.002V512h42.333v-51.074l20.667,0.002V512h42.333v-51.066l20.667,0.002V512h42.334v-51.059 l20.666,0.002V512h42.334v-51.051l20.666,0.002V512h42.334v-51.043l26.293,0.003v-26.293H512v-42.334h-51.04v-2.583l-15-0.05 v56.26H66.03V66.029h379.93V374.75l15,0.05v-3.133H512v-42.334h-51.04v-20.666H512v-42.334h-51.04v-20.666H512v-42.334h-51.04 v-20.666H512v-42.334h-51.04v-20.666H512z M460.964,92.333H497v12.334h-36.036V92.333z M51.036,104.667H15V92.333h36.036V104.667 z M51.036,167.667H15v-12.334h36.036V167.667z M51.036,230.667H15v-12.334h36.036V230.667z M51.036,293.667H15v-12.334h36.036 V293.667z M51.036,356.667H15v-12.334h36.036V356.667z M51.036,419.667H15v-12.334h36.036V419.667z M460.964,407.333H497v12.334 h-36.036V407.333z M407.333,460.964h12.334V497h-12.334V460.964z M344.333,460.964h12.334V497h-12.334V460.964z M281.333,460.964 h12.334V497h-12.334V460.964z M218.334,460.964h12.333V497h0h-12.333V460.964z M155.334,460.964h12.333V497h0h-12.333V460.964z  M92.333,460.964h12.333V497H92.333V460.964z M104.666,51.036H92.333V15h12.333V51.036z M167.666,51.036h-12.333V15h12.333 V51.036z M230.666,51.036h-12.333V15h12.333V51.036z M293.667,51.036h-12.334V15h12.334V51.036z M356.667,51.036h-12.334V15 h12.334V51.036z M419.667,51.036h-12.334V15h12.334V51.036z M460.964,344.333H497v12.334h-36.036V344.333z M460.964,281.333H497 v12.334h-36.036V281.333z M460.964,218.333H497v12.334h-36.036V218.333z M460.964,155.333H497v12.334h-36.036V155.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.05,234.5v-15h-17.963v-14.035l17.963,0.035v-15h-17.963v-15.587H321.5V157l-15-0.05v17.963h-14V157l-15-0.05v17.963 h-14V157l-15-0.05v17.963h-14V157l-15-0.05v17.963h-14V157l-15-0.05v17.963h-15.587V190.5H157l-0.05,14.95l17.963,0.035V219.5 H157l-0.05,14.95l17.963,0.035V248.5H157l-0.05,14.95l17.963,0.035V277.5H157l-0.05,14.95l17.963,0.035V306.5H157l-0.05,14.95 l17.963,0.035v15.602H190.5V355l15,0.05v-17.963h14V355l15,0.05v-17.963h14V355l15,0.05v-17.963h14V355l15,0.05v-17.963h14V355 l15,0.05v-17.963h15.587v-15.622l17.963,0.035v-15h-17.963v-14.035l17.963,0.035v-15h-17.963v-14.035l17.963,0.035v-15h-17.963 v-14.035L355.05,234.5z M189.913,322.087V189.913h132.174v132.174H189.913z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 260.08,
    width: 15,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 210.08,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 235.08,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.28,309.529 238.22,309.58 238.22,294.58 204.33,294.58  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.84,
    y: 91,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.84,
    y: 91,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.84,
    y: 91,
    width: 135.5,
    height: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.05,219.5 116,219.5 116,154 77.83,154 77.78,169 101,169 101,234.45 147.05,234.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.05,190.55 139.5,190.5 139.5,91 77.83,91 77.78,106 124.5,106 124.5,205.45 147.05,205.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.83,248.5 86.83,280 77.83,280 77.78,295 101.83,295 101.83,263.5 147,263.5 147.05,248.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.05,277.55 107,277.5 107,343 77.83,343 77.78,357.95 122,358 122,292.5 147,292.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.833,406 77.833,421 141.833,421 141.833,321.5 147,321.5 147,306.5 126.833,306.5 126.833,406  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.67,
    y: 406,
    width: 56.667,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.33,
    y: 406,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.33,
    y: 406,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,134.167h-48.5v48.5H428V134.167z M413,167.667h-18.5v-18.5H413V167.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,190.5h-48.5V239H428V190.5z M413,224h-18.5v-18.5H413V224z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421,278.08 406,278.029 406,341.08 421,341.13  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEd4);
export default __webpack_public_path__ + "static/media/ED4.efef022a.svg";
export { ForwardRef as ReactComponent };